var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 68,
    viewBox: "0 0 66 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24126 26.3974C14.2011 22.2809 22.3169 16.8981 29.4336 11.3941C33.2417 8.44904 37.3399 5.92369 41.0251 2.87515C41.5445 2.44553 42.8234 0.419475 43.5947 1.08322C44.8121 2.13088 45.992 3.95021 46.7364 5.36601C48.8989 9.47879 51.8827 13.606 54.9394 17.0696C57.3641 19.817 59.3329 22.1374 61.1762 25.33C62.1844 27.0763 64.6879 29.4592 64.5084 31.4006C64.0079 36.8131 58.9504 41.826 55.4793 45.3671C50.3787 50.5705 45.3816 55.7998 39.3164 59.7991C35.5542 62.2798 31.3125 63.5898 27.4647 65.8114C23.9203 67.8577 24.2113 67.5832 20.8358 64.6094C17.5111 61.6805 15.4539 58.5025 13.1983 54.5957C12.0241 52.562 9.92495 50.8058 8.29199 49.1255C7.05518 47.8529 6.60581 45.6802 5.93937 44.0788C5.24038 42.3992 5.30165 37.5825 3.76759 36.5791C2.26399 35.5957 0.519484 33.4338 0.941521 31.4973C1.28612 29.9161 14.4539 20.6474 3.45661 30.9941",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0513 33.9412C5.04713 35.396 7.96241 37.4852 10.9285 38.8505C11.9144 39.3043 13.5967 39.2192 14.3918 39.8401C16.5444 41.521 22.7615 40.5002 25.4015 40.7426C28.3817 41.0162 36.5489 45.1042 37.644 40.0795C39.7025 30.6341 42.0063 21.2318 44.0564 11.8246C44.4438 10.0472 43.9206 8.29257 44.2743 6.66965C45.351 1.72919 40.6109 4.84679 39.0082 5.77214",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallMail);
export default __webpack_public_path__ + "static/media/small_mail.7589884e2634495050ea0959c6669ea3.svg";
export { ForwardRef as ReactComponent };